module.exports = __webpack_public_path__ + "static/media/channel-icon.6b64aae2.svg";